import { ActionTypeNames, ActionValues, createActionCreators } from '../../../store/actions';
import { ThunkAction } from '../../../store/middleware';

const userCreateActions = createActionCreators<
	{ T: 'USER_CREATE_REQUEST' },
	{ T: 'USER_CREATE_RECEIVE', P: { username: string, ownerId: string } },
	{ T: 'USER_CREATE_FAILURE', P: { error: Error } }
	>('USER_CREATE_REQUEST', 'USER_CREATE_RECEIVE', 'USER_CREATE_FAILURE');

export const createUser = (username: string, password: string, ownerId: string): ThunkAction<any> =>
	async (dispatch, getState, { _deprecatedApi: api }) => {
		dispatch(userCreateActions.USER_CREATE_REQUEST());
		try {
			const user = await api.authentication.create(username, password, ownerId);
			dispatch(userCreateActions.USER_CREATE_RECEIVE({ username: user.getUsername(), ownerId }));
		} catch (error) {
			dispatch(userCreateActions.USER_CREATE_FAILURE({ error }));
			throw error;
		}
	};

const userUpdateActions = createActionCreators<
	{ T: 'USER_UPDATE_REQUEST' },
	{ T: 'USER_UPDATE_RECEIVE', P: { [key: string]: string } },
	{ T: 'USER_UPDATE_FAILURE', P: { error: Error } }
	>('USER_UPDATE_REQUEST', 'USER_UPDATE_RECEIVE', 'USER_UPDATE_FAILURE');

export const updateCurrentUser = (attributes: { [key: string]: string }): ThunkAction<any> => async (dispatch, getState, { _deprecatedApi: api }) => {
	dispatch(userUpdateActions.USER_UPDATE_REQUEST());
	try {
		await api.authentication.update(attributes);
		dispatch(userUpdateActions.USER_UPDATE_RECEIVE(attributes));
	} catch (error) {
		dispatch(userUpdateActions.USER_UPDATE_FAILURE({ error }));
		throw error;
	}
};

export const passwordResetActions = createActionCreators<
	{ T: 'PASSWORD_RESET_REQUEST', P: { id: string } },
	{ T: 'PASSWORD_RESET_RECEIVE', P: { id: string } },
	{ T: 'PASSWORD_RESET_FAILURE', P: { error: Error, id: string } }
	>('PASSWORD_RESET_REQUEST', 'PASSWORD_RESET_RECEIVE', 'PASSWORD_RESET_FAILURE');

export const resetPassword = (customerId: string, from: string, to: string): ThunkAction => async (dispatch, state, { _deprecatedApi: api }) => {
	dispatch(passwordResetActions.PASSWORD_RESET_REQUEST({ id: customerId }));
	try {
		await api.authentication.changeCurrentUserPassword(from, to);
		dispatch(passwordResetActions.PASSWORD_RESET_RECEIVE({ id: customerId }));
	} catch (error) {
		dispatch(passwordResetActions.PASSWORD_RESET_FAILURE({ error, id: customerId }));
	}
};

const actions = { ...userCreateActions, ...userUpdateActions, ...passwordResetActions };

type UserActions = ActionValues<typeof actions>;
type UserActionTypes = ActionTypeNames<UserActions>;
export type Actions = UserActions[keyof UserActions];
export const ActionTypes = Object.keys(actions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as UserActionTypes);
